import type { TocItem } from "../../lib/posts";

type TableOfContentsProps = {
  items: TocItem[];
};

export function TableOfContents({ items }: TableOfContentsProps) {
  if (items.length === 0) return null;

  return (
    <nav className="toc" aria-labelledby="toc-title">
      <h2 id="toc-title">Contents</h2>
      <ol>
        {items.map((item) => (
          <li key={item.id} className={item.level === 3 ? "toc__item toc__item--nested" : "toc__item"}>
            <a href={`#${item.id}`}>{item.text}</a>
          </li>
        ))}
      </ol>
    </nav>
  );
}
